/* global $ */
import { createElement, PropTypes } from 'rlink-react';

import { Picture } from 'rlink-repos/content-components';
import { ArticleComponent } from 'rlink-blog/component';
import getArticleLoader from 'helpers/getArticleLoader';

export default class ArticleSummary extends ArticleComponent {
  render () {
    let {articleSummary} = this.props;
    return (
      <article className="node node-news node-promoted node-teaser">
        <div className="field field-name-field-images field-type-image field-label-hidden field-wrapper">
          <Picture
            src={articleSummary.bannerImageFormats.src}
            widths={articleSummary.bannerImageFormats.widths}
            heights={articleSummary.bannerImageFormats.heights}
            formats={articleSummary.bannerImageFormats.formats} />
        </div>
        <div className="content-column">
          <div className="container">
            <div>
              <h4 className="node-title noline">{articleSummary.title}</h4>
              {this.formatDate(articleSummary.publishedOn)}
            </div>
          </div>
        </div>
        <div className="overlay-column">
          <a href={this.href()} onClick={ev => {
            ev.persist();
            ev.preventDefault();
            getArticleLoader().show(() => {
              $('.ajax-node').hide();
              this.redirectToContent(ev, 'home');
            });
          }}>
            <div className="picture-border">
              <div className="container">
                <div>
                  Read More
                </div>
              </div>
            </div>
          </a>
        </div>
      </article>
    );
  }
}

ArticleSummary.propTypes = {
  articleSummary: PropTypes.shape({
    title: PropTypes.string,
    slug: PropTypes.string,
    publishedOn: PropTypes.string,
    bannerImageFormats: PropTypes.shape({
      src: PropTypes.string,
      widths: PropTypes.arrayOf(PropTypes.number),
      heights: PropTypes.arrayOf(PropTypes.number),
      formats: PropTypes.arrayOf(PropTypes.shape({
        contentType: PropTypes.string,
        fileExt: PropTypes.string,
      })),
    }),
  }),
};



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/components/News/ArticleSummary.jsx